import CryptoJS from "crypto-js";

const encrypt_cipher_key = "m!m3@2023#s3cr3t@T0y|3tK3y|myportal";
export function encrypt(data) {
  if (typeof data == "object") {
    data = JSON.stringify(data);
  } else {
    data = data.toString();
  }
  return CryptoJS.AES.encrypt(data, encrypt_cipher_key).toString();
}

export function decrypt(cipher_text) {
  if (!cipher_text) {
    return "";
  }
  try {
    let decrypt_value = CryptoJS.AES.decrypt(
      cipher_text,
      encrypt_cipher_key,
    ).toString(CryptoJS.enc.Utf8);

    try {
      return JSON.parse(decrypt_value);
    } catch (e) {
      if (decrypt_value == "null") {
        return null;
      } else {
        return decrypt_value.toString();
      }
    }
  } catch (error) {
    console.log("decryption error utilities-->", error);
    localStorage.clear();
    window.location.href = "/login";
    alert("Detect unauthorized activities");
  }
}
